import { useMemo } from 'react';

import { useExpandingButtonContext } from 'components/ExpandingButton/context';
import { ChevronUp } from 'lucide-react';

const ButtonContent: React.FunctionComponent = function () {
  const { open } = useExpandingButtonContext();
  const iconClassName = useMemo(
    () =>
      ['my-auto transition-all', open ? 'rotate-180' : 'rotate-0'].join(' '),
    [open],
  );
  return (
    <div className="flex flex-row gap-x-3 justify-center bg-purple-100 px-3 py-4 text-14-22">
      <p>Need help? Click here</p>
      <ChevronUp className={iconClassName} size={20} />
    </div>
  );
};

export default ButtonContent;
